export const defaultSelectedPricing = (subscriptionUid, pricings) => {
  return pricings?.subscriptions.find(
    (pricing) => pricing.uid === subscriptionUid
  );
};

export const discountedPricingIfAvailable = (
  subscriptionUid,
  isReferralAdded,
  discountedPricings
) => {
  if (isReferralAdded && !!discountedPricings) {
    return discountedPricings.find(
      (pricing) => pricing.subscription?.uid === subscriptionUid
    )?.subscription;
  }
  return null;
};
